import { IdiomaService } from './../../providers/idioma/idioma.service';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import * as allSettled from 'promise-all-settled';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { TranslateService } from 'ng2-translate';
import { EspacioFormulario } from '../../domain/EspacioFormulario';

import {
	Predicate
} from 'breeze-client';
import { Idioma } from '../../domain/Idioma';
import { Constantes } from '../../domain/constantes';
import { AppComponent } from '../../app.component';
import { PermisosService, Permisos } from '../../providers/authentication/permisos.service';
import { BreadcrumbService } from '../../breadcrumb.service';
import { Entidad } from '../../domain/Entidad';
import { UsuarioFormulario } from '../../domain/UsuarioFormulario';




@Component({
	templateUrl: './SelectorEspacio.component.html',
	styleUrls: ['./SelectorEspacio.component.scss']
})

export class SelectorEspacioComponent implements OnInit, OnDestroy {

	spinner: HTMLElement;
	blockUI: HTMLElement;

	msgs: Message[] = [];
	MENSAJE_NO_ESPACIOS = '';
	public entidad: any = { ESPACIOS: [] };
	public listaEspacios = [];
	public crearVisible = false;

	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	private formValido;

	/* ** @INPUTS de FormularioEspacio ** */
	public edicion: boolean;
	public espacioSeleccionado: EspacioFormulario = new EspacioFormulario();
	public limpiarImagen = false;

	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	private ruta_inicial = '/espacios';
	public permisos: Permisos = new Permisos();
	private usuario;
	
	constructor(
		private appComponent: AppComponent,
		private router: Router,
		private entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		public idiomaService: IdiomaService,
		private translate: TranslateService,
		private zone: NgZone,
		private breadcrumbService: BreadcrumbService,
		private permisosService: PermisosService,
		
	) {
		const that = this;
		this.MENSAJE_NO_ESPACIOS = this.translate.instant('SelectorEspacios.sinespacios');
		// Inicializamos Spinner
		that.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		that.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		this.breadcrumbService.setItems([
		]);

		this.entityManager.getIDIOMA()
		.then(function(idiomasENTIDAD: any ){

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
		});

	 }

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		this.appComponent.ocultarMenuLateral();

		this.espacioSeleccionado = new EspacioFormulario();

		this.obtenerENTIDAD()
		.then(function () {
			return that.comprobarPermisos();
		})
		.then(function () {
			return that.permisosService.getRutaPaginaInicio(that.usuario.Id);
		})
		.then(function(_ruta){
			if (_ruta && _ruta.length > 0) {
				that.ruta_inicial = _ruta[0];
				console.log(that.ruta_inicial)
			}

			that.mostrarCrear();
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.appComponent.showError(e);
		});

	}

	ngOnDestroy() {

		this.appComponent.mostrarMenuLateral();

		this.entityManager.RejectChanges();
	}

	comprobarPermisos(that?) {
		that = this !== undefined ? this : that;
		const userId = that.authService.getIdUsuario();
		return that.permisosService.getPermisosUsuario(userId)
		.then(function(permisos){
			that.permisos = permisos;
		})
		.catch(function(err){
			throw err;
		});
	}

	obtenerUSUARIO(){
		const that = this;
		const entityManager = that.entityManager;

		let includes = 'ESPACIOS, PERFIL, PERFIL.FUNCIONALIDADES, ';
		includes = includes + 'ESPACIOS.ESPACIO.IDIOMAS.IDIOMA, ';

		includes = includes + 'ESPACIOS.ESPACIO.FOTOS';

		const userId = this.authService.getIdUsuario();
		const predicado = new Predicate('Id', '==', userId);
		const promises: any[] = [];

		return entityManager.getUSUARIO(predicado, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY usuario');
			}
			else {
				console.log('USUARIO CARGADO CORRECTAMENTE');
				that.usuario = entidades[0];

				that.listaEspacios = [];
				that.usuario.ESPACIOS.forEach(usuarioEspacio => {
					if (usuarioEspacio.ESPACIO !== null) {
						const espacio = new EspacioFormulario(usuarioEspacio.ESPACIO);
						if (espacio.Imagen === null || espacio.Imagen === undefined || espacio.Imagen === ''){
							espacio.Imagen = that.authService.getFotoPorDefecto();
						}
						that.listaEspacios.push(espacio);
					}
				});
				console.log(that.listaEspacios)

				if (that.listaEspacios && that.listaEspacios.length > 0) {
					that.listaEspacios.sort( (one: EspacioFormulario, two: EspacioFormulario) => {
						return one.Nombre > two.Nombre ? 1 : -1;
					});
				}

			}

			return allSettled(promises);
		})
		.then(function (fotosBlob) {
			fotosBlob.forEach(blob => {
				const espacio = that.listaEspacios.find(x => x.Id === blob.result.oFoto.IdEspacio);
				espacio.Imagen = blob.result.blob;
			});
			return that.entidad;
		})

		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	/* ** Funciones preparacion Vista  ** */
	obtenerENTIDAD() {
		const that = this;
		const idEntidad = this.authService.getIdEntidad();
		return this.entityManager.getEntidadById(idEntidad, undefined)
		.then(function (entidad) {
			that.entidad = entidad;
			return that.obtenerUSUARIO();
		});
	}

	obtenerESPACIOS() {
		const that = this;

		let includes = 'IDIOMAS.IDIOMA, ';
		includes = includes + 'NIVELS.ALAS.SECCIONS.NODOS.CONTENIDOS, ';
		includes = includes + 'RUTAS_SUGERIDA, ';
		includes = includes + 'NOTICIAS, ';
		includes = includes + 'CONTENIDOS, ';
		includes = includes + 'FOTOS';

		return this.entityManager.getESPACIO(undefined , includes)
		.then(function (espacios) {
			console.log(espacios)
			that.listaEspacios = [];
			espacios.forEach( elemento => {
				const espacio = new EspacioFormulario(elemento);
				if (espacio.Imagen === null || espacio.Imagen === undefined || espacio.Imagen === ''){
					espacio.Imagen = that.authService.getFotoPorDefecto();
				}
				that.listaEspacios.push(espacio);
				that.spinner.style.display = 'none';
			});

			if (that.listaEspacios && that.listaEspacios.length > 0) {
				that.listaEspacios.sort( (one: EspacioFormulario, two: EspacioFormulario) => {
					return one.Nombre > two.Nombre ? 1 : -1;
				});
			}

			return that.entidad;
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	mostrarCrear() {
		this.crearVisible = false;
		if (this.permisos.Selector_Espacio_add_espacio === 2) {
			// const rol = this.authService.getRole();
			// if (rol === Constantes.ADMINISTRADOR_ENTIDAD) {
			this.crearVisible = true;
			// }
			// else{
			// this.crearVisible = false;
			// }
		}
	}

	/* **  Acciones ** */
	selecionarEspacioPresionado(espacio) {
		const that = this;
		this.authService.setIdEspacio(espacio.Id);
		this.authService.setAreaEspacio(espacio.Area);

		this.permisosService.construirMenu()
		.then(function(res){
			that.zone.run(() => that.router.navigateByUrl(that.ruta_inicial));
			that.authService.setFotoPorDefecto(espacio.Imagen);
		});
	}

	anadirEspacioPresionado() {
		const espacios = this.entidad.ESPACIOS;
		if (this.entidad.Licencias > espacios.length) {
			this.espacioSeleccionado = new EspacioFormulario();
			this.espacioSeleccionado.Idiomas = this.idiomaService.newMapEspacioIdiomas(this.idiomas);
			this.edicion = false;
			this.visible = true;
		}
		else {
			this.appComponent.showError(this.translate.instant('SelectorEspacios.sinlicencias'));
			console.log('No quedan Licencias.');
		}
	}

	editarEspacioPresionado(espacio) {
		this.espacioSeleccionado = espacio;
		this.edicion = true;
		this.visible = true;
	}

	onShowFormularioEspacio(){
		console.log('onShowFormularioEspacio');
		this.limpiarImagen = true;

		// Truco para limpiar la foto seleccionada
		/*const selectorImagen = (<HTMLInputElement>document.getElementById('selectorImagen').getElementsByClassName('ui-button')[3]);
		if (selectorImagen !== undefined){
			(<HTMLInputElement>document.getElementById('selectorImagen').getElementsByClassName('ui-button')[3]).click();
		}
		*/

	}

	onCloseFormularioEspacio(){
		console.log('onCloseFormularioEspacio');
		const esp = new EspacioFormulario(this.espacioSeleccionado.ENTIDAD);

		let itemIndex = this.listaEspacios.findIndex(item => item.Id === esp.Id);
		this.listaEspacios[itemIndex] = esp;

		this.espacioSeleccionado = Object.assign([], esp);
	}

	/* *** @Outlets de Formulario Espacio *** */
	onElementoEspacioGuardado($event) {

		if (!this.edicion) {
			this.listaEspacios.push($event.ENTIDAD);
		}

		const idEspacio = $event.ENTIDAD.Id;
		const espacio = this.entidad.ESPACIOS.find(x => x.Id === idEspacio);

		if ($event.Imagen) {
			espacio.Imagen = $event.Imagen;
		}
		const that = this;
		this.obtenerESPACIOS()
		.then(function(){
			that.visible = false;
			that.spinner.style.display = 'none';
			that.appComponent.showSuccess(that.translate.instant('SelectorEspacios.espacioguardadook'));
		});
	}

	onElementoEspacioEliminado($event) {
		if ($event !== undefined) {
			this.listaEspacios = this.listaEspacios.filter(x => x.Id !== $event.ENTIDAD.Id);
			this.appComponent.showSuccess(this.translate.instant('SelectorEspacios.espacioeliminadook'));
		}
		else{
			this.appComponent.showError(this.translate.instant('SelectorEspacios.espacioeliminadoerror'));
		}
		this.visible = false;
		this.spinner.style.display = 'none';
	}

	onElementoError($evento) {
		this.appComponent.showError($evento);
	}

	onFormularioValidation($evento) {
		this.formValido = $evento;
	}


	/* *** Mouse ScrollOver *** */
	mostrarEditar(espacio) {
		// Muestra u Oculta el boton editar al pasar el raton por encima del elemento
		espacio.editarVisible = true;
	}

	ocultarEditar(espacio) {
		// Muestra u Oculta el boton editar al pasar el raton por encima del elemento
		espacio.editarVisible = false;
	}


	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/SelectorEspacios/SelectorEspacio.component.ts